<template>
  <div class="verifyV2">
    <!-- list 列表 -->
    <div id="listbox" v-show="!loading && lists.length">
      <img src="@/assets/img/verifyV2/detailpost.png" />
      <ul class="lists">
        <li v-for="(item, index) in lists" :key="index">
          <div class="header">
            <div class="omit">{{ item.gcName }}</div>
            <div>NO.{{ index + 1 }}</div>
          </div>
          <div class="info" v-show="item.redeemCode">
            <div class="title">兑换码</div>
            <div class="omit">{{ item.redeemCode }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.redeemCode"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
            <div
              class="btn open-btn"
              v-if="isHttpLink(item.redeemCode)"
              @click="openLink(item.redeemCode)"
            >
              打开
            </div>
          </div>
          <div class="info" v-show="item.cardNo">
            <div class="title">卡&nbsp;&nbsp;&nbsp;号</div>
            <div class="omit">{{ item.cardNo }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.cardNo"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="info" v-show="item.cardPwd">
            <div class="title">卡&nbsp;&nbsp;&nbsp;密</div>
            <div class="omit">{{ item.cardPwd }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.cardPwd"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="info" v-show="item.shortUrl">
            <div class="title">短&nbsp;&nbsp;&nbsp;链</div>
            <a class="omit link" :href="item.shortUrl">{{ item.shortUrl }}</a>
            <div
              class="btn"
              v-clipboard:copy="item.shortUrl"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="info" v-show="item.verifyCode">
            <div class="title">验证码</div>
            <div class="omit">{{ item.verifyCode }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.verifyCode"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="goodDetail" v-if="item.describe">
            <div class="title">
              <div>商品详情</div>
              <div
                :class="[showDetailIndex === index ? 'active btn' : 'btn']"
                @click="
                  showDetailIndex = showDetailIndex === index ? null : index
                "
              >
                {{ showDetailIndex === index ? '收起' : '查看' }}
                <img src="@/assets/img/verifyV2/arrow.png" />
              </div>
            </div>
            <div
              class="describe"
              v-html="item.describe"
              v-show="showDetailIndex === index"
            />
          </div>
        </li>
      </ul>
    </div>

    <!-- 系统拥挤要刷新 -->
    <div id="crowded" v-show="!loading && !lists.length">
      <div class="crowded-box">
        <img src="@/assets/img/YonghuiSync/crowded.png" />
        <h1>活动太火爆了，请您稍后尝试！</h1>
        <div class="refresh" @click="loadData()">
          <img src="@/assets/img/verifyV2/refresh.png" />刷 新 页 面
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryVerifyRes } from '@/api/verifyV2.js'
export default {
  data() {
    return {
      lists: [
        // {
        //   describe: '<p>112商品详情说明</p>',
        //   effectiveEndTime: 1759679999000,
        //   gcName: 'spu卡密061410元',
        //   ordNo: 'OC202507070935323297',
        //   ordSubNo: 'OSC2025070709354350756',
        //   redeemCode: 'http://localhost:8081/#/verifyV2List'
        // },
        // {
        //   describe: '<p>111222</p>',
        //   effectiveEndTime: 1759679999000,
        //   gcName: '0621spu10元',
        //   ordNo: 'OC202507070935323297',
        //   ordSubNo: 'OSC2025070709354350756',
        //   redeemCode: '7522224624466662'
        // }
      ],
      showDetailIndex: null,
      loading: false
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        this.loading = true
        this.$toast.loading('加载中...')
        const { code, data, message } = await queryVerifyRes(this.$route.query)
        this.$toast.clear()
        this.loading = false
        if (code === 0 && data.length > 0) {
          this.lists = data || []
        } else {
          switch (code) {
            case 5: {
              this.$toast.fail(message)
              // token失效调回首页
              this.$router.push({
                name: 'verifyV2'
              })
              break
            }
          }
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    isHttpLink(value) {
      return typeof value === 'string' && /^https?:\/\//i.test(value)
    },
    openLink(url) {
      if (!this.isHttpLink(url)) return
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    copySuccess() {
      this.$toast({
        message: '复制成功'
      })
    },
    copyError() {
      this.$toast({
        message: '复制失败'
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/style/YonghuiSync.less';
.lists {
  padding: 3.07vw 3.9vw 7.15vw !important;
  & > li {
    padding-bottom: 4.6vw !important;
    .info {
      padding: 4.6vw 6.5vw 0vw !important;
      .link {
        color: #fffd3d;
      }
      .open-btn {
        margin-left: 1.5vw;
      }
    }
  }
}
.goodDetail {
  // padding: 5.85vw 6.5vw 0vw;
  padding: 0 3.9vw 0.9vw;
  .title {
    margin-top: 4.6vw;
    padding: 4.6vw 2.2vw 0;
    border-top: 1px dashed #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 3.64vw;
    color: #ffffff;
    .btn {
      color: #fff2b1;
      position: relative;
      padding-right: 2.5vw;
      display: flex;
      align-items: center;
      img {
        width: 3.36vw;
        height: 1.6vw;
        margin-left: 1vw;
        transition: transform 0.3s ease;
      }
      // &::after {
      //   content: '';
      //   position: absolute;
      //   right: 0;
      //   top: 50%;
      //   transform: translateY(-50%);
      //   width: 0;
      //   height: 0;
      //   border-left: 5px solid transparent;
      //   border-right: 5px solid transparent;
      //   border-top: 8px solid #fff2b1; /* 颜色与文字一致 */
      //   transition: transform 0.3s ease;
      // }
      &.active {
        img {
          transform: rotate(180deg);
        }
      }
    }
  }

  .describe {
    background: #ffffff;
    border-radius: 4vw;
    margin-top: 4.6vw;
    padding: 4vw;
    font-size: 3.64vw;
    color: #333333;
    // margin: 3.9vw 3.9vw 0;
  }
}
#crowded {
  background: #ffebd2;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  .crowded-box {
    flex: auto;
    & > img {
      display: block;
      margin: auto;
      width: 70.59vw;
    }
    & > h1 {
      font-size: 3.2vw;
      padding: 9.3vw 0 17.3vw;
      color: #999999;
      text-align: center;
    }
    .refresh {
      color: #ea1300;
      font-size: 3.2vw;
      line-height: 1.5;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 3.2vw;
        margin: 0 3vw 0 0;
      }
    }
  }
}
.verifyV2 {
  background: #ffebd2;
  min-height: 100vh;
}
</style>
